import React, { useState } from 'react';
import find from 'lodash/find';
import ColorPicker from '../../components/components/common/color_picker.js';
import FormSelect from '../../components/components/common/form_select_without_polaris.js';
import FormNested from '../../components/components/product/form_nested.js';
import FormCheckbox from '../../components/components/common/form_checkbox_without_polaris.js';
import FormCheckboxMultiple from '../../components/components/common/form_checkbox_multiple.js';
import FormRadio from '../../components/components/common/form_radio.js';
import {
  CHECKBOX_TYPE,
  RADIO_TYPE,
  FILE_TYPE
} from '../../components/constants';

export default (
  {
    classStyle,
    currentSetting,
    defaultSetting,
    fieldKey,
    includeBlank,
    onChange,
    placeholder,
    style,
    translation,
    type,
  }
) => {
  const inputRef = React.createRef(null);
  const propCurrentValue = currentSetting[fieldKey];
  const [currentValue, setCurrentValue] = useState(propCurrentValue);
  const onBlur = () => onChange(fieldKey, currentValue);
  const handleChange = (value) => {
    setCurrentValue(value);
    if (inputRef && document.activeElement !== inputRef.current) {
      onChange(fieldKey, value);
    }
  }

  if (Array.isArray(defaultSetting)) {
    const inputSettings = find(defaultSetting, (x) => x.key === fieldKey);
    const { defaultValue } = inputSettings;
    switch (inputSettings.data_type) {
      case 'color':
        return (
          <ColorPicker
            name={fieldKey}
            className={`${classStyle}`}
            value={propCurrentValue === undefined ? defaultValue : propCurrentValue}
            onChange={(value) => onChange(fieldKey, value)}
          />
        );
    }
  }

  // below is old implementation which made many assumptions about data types
  const defaultValue = defaultSetting[fieldKey];

  if (type === FILE_TYPE) {
    return (
      <input
        name={fieldKey}
        type={type}
        className={`form-control ${classStyle}`}
        style={{ ...style }}
        onChange={({target}) => onChange(fieldKey, target.files[0])}
      />
    );
  }

  if (Array.isArray(defaultValue)) {
    // hide select if only one option
    // if (defaultValue.length > 1) {
    switch (type) {
      case CHECKBOX_TYPE:
        return (
          <FormCheckboxMultiple
            name={fieldKey}
            value={propCurrentValue}
            options={defaultValue.map((x) => (Array.isArray(x) ? x : [x, x]))}
            onChange={(value) => onChange(fieldKey, value)}
            showLabel={false}
            classStyle={classStyle}
            style={style}
          />
        );
      case RADIO_TYPE:
        return (
          <FormRadio
            name={fieldKey}
            value={propCurrentValue}
            options={defaultValue.map((x) => (Array.isArray(x) ? x : [x, x]))}
            onChange={(value) => onChange(fieldKey, value)}
            classStyle={classStyle}
            style={style}
          />
        );
      default:
        return (
          <FormSelect
            name={fieldKey}
            value={propCurrentValue}
            options={defaultValue.map((x) => (Array.isArray(x) ? x : [x, x]))}
            onChange={(value) => onChange(fieldKey, value)}
            includeBlank={includeBlank}
            classStyle={classStyle}
            style={style}
            blankText={translation ? translation.key('fieldDropdownPrompt') : 'Select...'}
          />
        );
    }
    // return null;
  }

  if (typeof defaultValue === 'object' && defaultValue !== null) {
    const { tag, description, ...attrs } = defaultValue;
    const inputList = { FormNested, FormCheckbox, input: 'input' };
    const Tag = inputList[tag] ? inputList[tag] : tag;

    if (tag === 'FormNested') {
      attrs.values = propCurrentValue;
    }

    return (
      <div>
        <Tag
          value={propCurrentValue}
          {...attrs}
          className="form-control"
          onChange={(e) => {
            // could be native input or component element
            const result = e.target ? e.target.value : e;
            onChange(fieldKey, result, tag);
          }}
        />
        {description && <p className="m-t-xs text-muted">{description}</p>}
      </div>
    );
  }

  if (typeof defaultValue === 'boolean') {
    return (
      <FormCheckbox
        name={fieldKey}
        value={propCurrentValue === undefined ? defaultValue : propCurrentValue}
        onChange={(value) => onChange(fieldKey, value)}
        classStyle={classStyle}
        style={style}
      />
    );
  }

  if (typeof defaultValue === 'string') {
    // for color code
    if (defaultValue.indexOf('#') === 0 || defaultValue === 'transparent') {
      return (
        <ColorPicker
          name={fieldKey}
          className={classStyle}
          value={propCurrentValue === undefined ? defaultValue : propCurrentValue}
          onChange={(value) => onChange(fieldKey, value)}
        />
      );
    }

    if (type === 'text') {
      return (
        <textarea
          ref={inputRef}
          name={fieldKey}
          className={`form-control ${classStyle}`}
          style={{ ...style }}
          value={currentValue}
          placeholder={placeholder || defaultValue}
          onChange={({ target: { value } }) => handleChange(value)}
          onBlur={onBlur}
        />
      );
    }

    return (
      <input
        ref={inputRef}
        name={fieldKey}
        type="text"
        className={`form-control ${classStyle}`}
        style={{ ...style }}
        value={currentValue}
        placeholder={placeholder || defaultValue}
        onChange={({ target: { value } }) => handleChange(value)}
        onBlur={onBlur}
      />
    );
  }

  return (
    <input
      ref={inputRef}
      name={fieldKey}
      type="number"
      min="1"
      className={`form-control ${classStyle}`}
      style={{ ...style }}
      value={currentValue}
      placeholder={fieldKey === 'interval' ? 'hour' : defaultValue}
      onChange={({ target: { value } }) => handleChange(value)}
      onBlur={onBlur}
    />
  );
}
